<template>
  <Evform
    ref="Evform"
    :loading="loading"
    :model="model"
    :urlSubmit="urlSubmit"
    :submitType="submitType"
    :afterSubmit="afterSubmit"
    :paramsSubmit="true"
    :btnShowReset="false"
    :btnShowCancal="false"
  >
    <el-col :span="12">
      <el-form-item label="验证码类型" prop="CaptchaType" :rules="this.validate.rules({required:true})">
        <el-select v-model.trim="model.CaptchaType" placeholder="请选择验证码类型">
          <el-option label="大小写字母" value="5">大小写字母</el-option>
          <el-option label="纯数字" value="6">纯数字</el-option>
          <el-option label="小写字母" value="7">小写字母</el-option>
          <el-option label="大写字母" value="8">大写字母</el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="验证码长度"
        prop="CaptchaLen"
        :rules="this.validate.rules({required:true, type:'number', min:2, max:6})"
      >
        <el-input-number
          v-model.trim="model.CaptchaLen"
          :min="2"
          :max="6"
          :controls="true"
          placeholder="请设置验证码长度"
        ></el-input-number>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="图片上传类型"
        prop="FileUploadImageAllowType"
        :rules="this.validate.rules({required:true, reg:/^([0-9a-zA-Z]+,)*[0-9a-zA-Z]+$/, message:'输入内容格式不正确'})"
      >
        <el-input
          v-model.trim="model.FileUploadImageAllowType"
          placeholder="请设置图片上传类型"
          class="boxWidth"
        ></el-input>
        <el-tooltip
          class="item"
          effect="dark"
          content="只允许输入数字、英文字符和英文逗号(',')，且不允许逗号开头或结尾"
          placement="left"
        >
          <i class="el-icon-info tips-item"></i>
        </el-tooltip>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="图片上传大小"
        prop="FileUploadImageSizeLimit"
        :rules="this.validate.rules({required:true, type:'number', min:1, max:104857600})"
      >
        <el-row>
          <el-input-number
            v-model.trim="model.FileUploadImageSizeLimit"
            :min="1"
            :max="104857600"
            :controls="true"
            @change="handleChange('changeResult1')"
            placeholder="请设置图片上传大小"
            class="inputNum"
          ></el-input-number>
          <div class="fileSize">
            <span>{{fileSizeData.fileSize1}}</span>
          </div>
        </el-row>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="视频上传类型"
        prop="FileUploadVideoAllowType"
        :rules="this.validate.rules({required:true, reg:/^([0-9a-zA-Z]+,)*[0-9a-zA-Z]+$/, message:'输入内容格式不正确'})"
      >
        <el-input
          v-model.trim="model.FileUploadVideoAllowType"
          placeholder="请设置视频上传类型"
          class="boxWidth"
        ></el-input>
        <el-tooltip
          class="item"
          effect="dark"
          content="只允许输入数字、英文字符和英文逗号(',')，且不允许逗号开头或结尾"
          placement="left"
        >
          <i class="el-icon-info tips-item"></i>
        </el-tooltip>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="视频上传大小"
        prop="FileUploadVideoSizeLimit"
        :rules="this.validate.rules({required:true, type:'number', min:1, max:104857600})"
      >
        <el-row>
          <el-input-number
            v-model.trim="model.FileUploadVideoSizeLimit"
            :min="1"
            :max="104857600"
            :controls="true"
            @change="handleChange('changeResult2')"
            placeholder="请设置视频上传大小"
            class="inputNum"
          ></el-input-number>
          <div class="fileSize">
            <span>{{fileSizeData.fileSize2}}</span>
          </div>
        </el-row>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="音频上传类型"
        prop="FileUploadAudioAllowType"
        :rules="this.validate.rules({required:true, reg:/^([0-9a-zA-Z]+,)*[0-9a-zA-Z]+$/, message:'输入内容格式不正确'})"
      >
        <el-input
          v-model.trim="model.FileUploadAudioAllowType"
          placeholder="请设置音频上传类型"
          class="boxWidth"
        ></el-input>
        <el-tooltip
          class="item"
          effect="dark"
          content="只允许输入数字、英文字符和英文逗号(',')，且不允许逗号开头或结尾"
          placement="left"
        >
          <i class="el-icon-info tips-item"></i>
        </el-tooltip>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="音频上传大小"
        prop="FileUploadAudioSizeLimit"
        :rules="this.validate.rules({required:true, type:'number', min:1, max:104857600})"
      >
        <el-row>
          <el-input-number
            v-model.trim="model.FileUploadAudioSizeLimit"
            :min="1"
            :max="104857600"
            :controls="true"
            @change="handleChange('changeResult3')"
            placeholder="请设置音频上传大小"
            class="inputNum"
          ></el-input-number>
          <div class="fileSize">
            <span>{{fileSizeData.fileSize3}}</span>
          </div>
        </el-row>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="附件上传类型"
        prop="FileUploadFileAllowType"
        :rules="this.validate.rules({required:true, reg:/^([0-9a-zA-Z]+,)*[0-9a-zA-Z]+$/, message:'输入内容格式不正确'})"
      >
        <el-input
          v-model.trim="model.FileUploadFileAllowType"
          placeholder="请设置附件上传类型"
          class="boxWidth"
        ></el-input>
        <el-tooltip
          class="item"
          effect="dark"
          content="只允许输入数字、英文字符和英文逗号(',')，且不允许逗号开头或结尾"
          placement="left"
        >
          <i class="el-icon-info tips-item"></i>
        </el-tooltip>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="附件上传大小"
        prop="FileUploadFileSizeLimit"
        :rules="this.validate.rules({required:true, type:'number', min:1, max:104857600})"
      >
        <el-row>
          <el-input-number
            v-model.trim="model.FileUploadFileSizeLimit"
            :min="1"
            :max="104857600"
            :controls="true"
            @change="handleChange('changeResult4')"
            placeholder="请设置附件上传大小"
            class="inputNum"
          ></el-input-number>
          <div class="fileSize">
            <span>{{fileSizeData.fileSize4}}</span>
          </div>
        </el-row>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="缩略图宽度"
        prop="ImageZoomDefaultWidth"
        :rules="this.validate.rules({required:true, type:'number', min:1, max:1024})"
      >
        <el-input-number
          v-model.trim="model.ImageZoomDefaultWidth"
          :min="1"
          :max="1024"
          :controls="true"
          placeholder="请设置缩略图宽度"
        ></el-input-number>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item
        label="缩略图高度"
        prop="ImageZoomDefaultHeight"
        :rules="this.validate.rules({required:true, type:'number', min:1, max:1024})"
      >
        <el-input-number
          v-model.trim="model.ImageZoomDefaultHeight"
          :min="1"
          :max="1024"
          :controls="true"
          placeholder="请设置缩略图高度"
        ></el-input-number>
      </el-form-item>
    </el-col>
  </Evform>
</template>
<script>
export default {
  name: "sendCaptchaForm",
  data() {
    return {
      fileSizeData: {
        fileSize1: "", //图片大小
        fileSize2: "", //视频大小
        fileSize3: "", //音频大小
        fileSize4: "" //附件大小
      },
      loading: true,
      urlSubmit: "/wtcp-support/setups", //请求地址
      submitType: "put", //请求方式
      //表单数据
      model: {
        CaptchaType: "", //验证码类型
        CaptchaLen: 0, //验证码长度
        FileUploadImageAllowType: "", //图片上传类型
        FileUploadImageSizeLimit: 0, //图片上传大小
        FileUploadVideoAllowType: "", //视频上传类型
        FileUploadVideoSizeLimit: "", //视频上传大小
        FileUploadAudioAllowType: "", //音频上传类型
        FileUploadAudioSizeLimit: "", //音频上传大小
        FileUploadFileAllowType: "", //附件上传类型
        FileUploadFileSizeLimit: "", //附件上传大小
        ImageZoomDefaultWidth: "", //缩略图宽度
        ImageZoomDefaultHeight: "" //缩略图高度
      },
      appOption: [], //应用编码数据
      templateOption: [] //短信模板数据
    };
  },
  created() {
    this.loading = false;
    this.request.oprahfun(this);
    this.queryData();
  },
  methods: {
    // 图片大小、视频大小、音频大小、附件大小改变后换算
    handleChange(type) {
      if (type === "changeResult1") {
        this.fileSizeData.fileSize1 = this.changeUnit(
          this.model.FileUploadImageSizeLimit
        );
      }
      if (type === "changeResult2") {
        this.fileSizeData.fileSize2 = this.changeUnit(
          this.model.FileUploadVideoSizeLimit
        );
      }
      if (type === "changeResult3") {
        this.fileSizeData.fileSize3 = this.changeUnit(
          this.model.FileUploadAudioSizeLimit
        );
      }
      if (type === "changeResult4") {
        this.fileSizeData.fileSize4 = this.changeUnit(
          this.model.FileUploadFileSizeLimit
        );
      }
    },
    afterSubmit(resStatus) {
      if (resStatus.status == 1) {
        this.queryData();
      }
    },
    // 数据回显
    queryData: function() {
      var _this = this;
      this.request.oprahfun(this);
      this.loading = true;
      this.request.get("/wtcp-support/setups").then(res => {
        _this.loading = false;
        if (res.status == 1) {
          var resData = res.data;
          Object.keys(_this.model).forEach(function(key) {
            if (_this.model[key] == null) {
              _this.model[key] = "";
            } else {
              _this.model[key] = resData[key].value;
            }
          });
          _this.fileSizeData.fileSize1 = _this.changeUnit(
            _this.model.FileUploadImageSizeLimit
          );
          _this.fileSizeData.fileSize2 = _this.changeUnit(
            _this.model.FileUploadVideoSizeLimit
          );
          _this.fileSizeData.fileSize3 = _this.changeUnit(
            _this.model.FileUploadAudioSizeLimit
          );
          _this.fileSizeData.fileSize4 = _this.changeUnit(
            _this.model.FileUploadFileSizeLimit
          );
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    //单位转换
    changeUnit(limit) {
      var size = "";
      limit = parseInt(limit);
      if (isNaN(limit)) {
        return "";
      }
      if (limit < 0.1 * 1024) {
        //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B";
      } else if (limit < 0.1 * 1024 * 1024) {
        //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      var sizeStr = size + ""; //转成字符串
      var index = sizeStr.indexOf("."); //获取小数点处的索引
      var dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
      if (dou == "00") {
        //判断后两位是否为00，如果是则删除00
        size = sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    }
  }
};
</script>
<style lang="less" scoped>
// .el-input-number {
//   width: 100%;
// }
.inputNum.el-input-number {
  width: calc(100% - 25%);
}
.fileSize {
  width: 25%;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}
.boxWidth.el-input {
  width: calc(100% - 5%);
}
</style>